<template>
  <div class="data_table_main">
    <div class="search_bar">
      <div class="search_item">
        <span class="label">所属大棚：</span>
        <el-select
          v-model="greenhouseId"
          placeholder="选择大棚"
          size="mini"
          style="width: 180px"
          @change="handleGreenhouseChange"
        >
          <el-option
            v-for="item in greenhouseOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="search_item">
        <span class="label">设备类型：</span>
        <el-select
          v-model="deviceType"
          placeholder="选择设备类型"
          size="mini"
          style="width: 180px"
          @change="handleDeviceTypeChange"
        >
          <el-option
            v-for="(type, key) in deviceTypeOptions"
            :key="key"
            :label="key"
            :value="key"
          ></el-option>
        </el-select>
      </div>

      <div class="search_item">
        <span class="label">设备名称：</span>
        <el-select
          v-model="deviceId"
          placeholder="选择设备名称"
          size="mini"
          style="width: 180px"
          @change="handleDeviceNameChange"
        >
          <el-option
            v-for="device in deviceNameOptions"
            :key="device.id"
            :label="device.deviceName"
            :value="device.id"
          ></el-option>
        </el-select>
      </div>

      <div class="search_item">
        <span class="label">数据类型：</span>
        <el-radio-group
          v-model="dataType"
          size="mini"
          @change="handleDataTypeChange"
        >
          <el-radio-button label="MINUTES">实时</el-radio-button>
          <el-radio-button label="DAYS">近24小时</el-radio-button>
          <el-radio-button label="WEEKS">近一周</el-radio-button>
          <el-radio-button label="MONTHS">近一月</el-radio-button>
        </el-radio-group>
      </div>

      <div class="search_item">
        <el-date-picker
          v-model="times"
          style="width: 400px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="mini"
          @change="handleTimeChange"
        >
        </el-date-picker>
      </div>

      <el-button type="primary" size="mini" @click="handleQuery"
        >查询</el-button
      >
      <el-button type="success" size="mini" @click="handleExport" :loading="exportLoading"
        >导出</el-button
      >
    </div>

    <!-- 表格区域 -->
    <div class="table_container" v-loading="tableLoading">
      <el-table
        :key="tableKey"
        :data="tableData"
        border
        style="width: 100%"
        height="66vh"
        :header-cell-style="{
          background: '#1a3a5c',
          color: '#fff',
          borderColor: '#2680dd',
        }"
        :cell-style="getCellStyle"
      >
        <el-table-column type="index" label="序号" width="80" align="center" fixed="left" />
        <el-table-column prop="time" label="监测时间" width="200" align="center" fixed="left" />
        <el-table-column
          v-for="column in tableColumns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
        >
          <template slot-scope="scope">
            <span>{{
              formatCellValue(scope.row[column.prop], column.unit)
            }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination_container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import { getdeviceclassifylist, getallsblist, gethistorydata, exportMonitoringData } from "@/api/bot";
import dayjs from "dayjs";

export default {
  name: "StrawberryaiPcDataTable",
  props: {
    sbname: {
      type: String,
      default: "",
    },
    initialDeviceId: {
      type: String,
      default: "",
    },
    initialGreenhouseId: {
      type: String,
      default: "",
    },
    initialDeviceName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // 表格key，用于强制重新渲染
      tableKey: 0,
      // 大棚相关
      greenhouseOptions: [],
      greenhouseId: "",
      // 设备类型和设备名称
      deviceTypeOptions: {}, // { "设备类型名称": [设备列表] }
      deviceType: "",
      deviceNameOptions: [], // 当前设备类型下的设备列表
      deviceId: "",
      // 设备ID到sensorId的映射
      deviceIdToSensorIdMap: {},
      // 设备分类完整信息（包含variableTypeList）
      deviceClassifyInfo: {}, // { "设备类型名称": { classifyId, variableTypeList, ... } }
      // 设备ID到分类信息的映射
      deviceIdToClassifyInfoMap: {},
      // 设备变量限制信息（用于判断是否超限）
      deviceVariablesLimits: {}, // { type: { upperLimit, lowerLimit, unit } }
      // 数据类型
      dataType: "MINUTES",
      // 时间范围
      times: [
        dayjs().subtract(12, "hour").format("YYYY-MM-DD HH:mm:ss"),
        dayjs().format("YYYY-MM-DD HH:mm:ss"),
      ],
      // 表格相关
      tableData: [],
      tableColumns: [],
      tableLoading: false,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      exportLoading: false,
      // 设备类型对应的字段列表（参考 data_chart copy.vue）
      valuekeylist: {
        大气环境监测传感器: [
          {
            name: "温度",
            value: "temp",
            type:'ATMOSPHERIC_TEMPERATURE',
            unit: "℃",
          },
          {
            name: "湿度",
            value: "humi",
            type:'ATMOSPHERIC_HUMIDITY',
            unit: "%",
          },
          {
            name: "二氧化碳",
            value: "co2",
            type:'CARBON_DIOXIDE',
            unit: "ppm",
          },
          {
            name: "光照",
            value: "light",
            type:'ILLUMINATION',
            unit: "Lux",
          },
        ],
        土壤氮磷钾传感器: [
          {
            name: "含氮量",
            value: "nitrogen",
            type:'NITROGEN_CONTENT',
            unit: "mg/kg",
          },
          {
            name: "含磷量",
            value: "phosphorus",
            type:'PHOSPHORUS_CONTENT',
            unit: "mg/kg",
          },
          {
            name: "含钾量",
            value: "potassium",
            type:'POTASSIUM_CONTENT',
            unit: "mg/kg",
          },
        ],
        土壤温湿度EC传感器: [
          {
            name: "含水率",
            value: "water",
            type:'MOISTURE_CONTENT',
            unit: "%RH",
          },
          {
            name: "温度",
            value: "temp",
            type:'SOIL_TEMPERATURE',
            unit: "℃",
          },
          {
            name: "电导率",
            value: "conductivity",
            type:'ELECTRICAL_CONDUCTIVITY',
            unit: "us/cm",
          },
        ],
        土壤PH传感器: [
          {
            name: "PH值",
            value: "ph",
            type:'PH_VALUE',
            unit: "",
          },
        ],
        棚外气象站: [
          {
            name: "风力",
            value: "windRank",
            unit: "级",
          },
          {
            name: "风速",
            value: "windSpeed",
            unit: "m/s",
          },
          {
            name: "风向",
            value: "windDirection",
            unit: "",
          },
          {
            name: "温度",
            value: "temp",
            unit: "℃",
          },
          {
            name: "湿度",
            value: "humi",
            unit: "%",
          },
          {
            name: "光照",
            value: "light",
            unit: "",
          },
          {
            name: "大气压",
            value: "pressure",
            unit: "kPa",
          },
          {
            name: "累计雨量",
            value: "rainfall",
            unit: "mm",
          },
          {
            name: "瞬时雨量",
            value: "instantRainfall",
            unit: "mm",
          },
          {
            name: "当前雨量",
            value: "currentRainfall",
            unit: "mm",
          },
          {
            name: "日雨量",
            value: "yesterdayRainfall",
            unit: "mm",
          },
        ],
      },
    };
  },

  mounted() {
    this.fetchGreenhouseOptions();
  },
  watch: {
    // 监听初始值变化，在数据加载完成后设置
    initialGreenhouseId: {
      handler(newVal) {
        if (newVal && this.greenhouseOptions.length > 0) {
          this.$nextTick(() => {
            this.setInitialValues();
          });
        }
      },
      immediate: true,
    },
    initialDeviceId: {
      handler(newVal) {
        if (newVal && this.deviceNameOptions.length > 0) {
          this.$nextTick(() => {
            this.setInitialDevice();
          });
        }
      },
      immediate: true,
    },
    initialDeviceName: {
      handler(newVal) {
        if (newVal && this.deviceNameOptions.length > 0) {
          this.$nextTick(() => {
            this.setInitialDevice();
          });
        }
      },
      immediate: true,
    },
    // 监听设备名称选项变化，如果有初始设备ID或设备名称则设置
    deviceNameOptions: {
      handler() {
        if (
          (this.initialDeviceId || this.initialDeviceName) &&
          this.deviceNameOptions.length > 0
        ) {
          this.$nextTick(() => {
            this.setInitialDevice();
          });
        }
      },
      deep: true,
    },
  },

  methods: {
    // 获取大棚下拉选项
    async fetchGreenhouseOptions() {
      const formData = new FormData();
      formData.append("enableStatus", 1);
      const greenhouseRes = await axios.post(
        baseUrl + "/api/basic/greenhouse/selection",
        formData
      );
      this.greenhouseOptions = (greenhouseRes.data || []).map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
      // 如果有初始大棚ID，使用它；否则默认选中第一个大棚
      if (this.greenhouseOptions.length) {
        if (this.initialGreenhouseId) {
          // 检查初始大棚ID是否存在于选项中
          const exists = this.greenhouseOptions.some(
            (opt) => String(opt.value) === String(this.initialGreenhouseId)
          );
          if (exists) {
            this.greenhouseId = this.initialGreenhouseId;
            await this.handleGreenhouseChange();
            // 等待设备列表加载完成后设置初始设备
            this.$nextTick(() => {
              this.setInitialDevice();
            });
          } else {
            // 如果初始大棚ID不存在，使用第一个
            this.greenhouseId = this.greenhouseOptions[0].value;
            this.handleGreenhouseChange();
          }
        } else {
          // 默认选中第一个大棚
          this.greenhouseId = this.greenhouseOptions[0].value;
          this.handleGreenhouseChange();
        }
      }
    },
    // 设置初始值（大棚和设备）
    setInitialValues() {
      if (this.initialGreenhouseId && this.greenhouseOptions.length > 0) {
        const exists = this.greenhouseOptions.some(
          (opt) => String(opt.value) === String(this.initialGreenhouseId)
        );
        if (exists && this.greenhouseId !== this.initialGreenhouseId) {
          this.greenhouseId = this.initialGreenhouseId;
          this.handleGreenhouseChange();
        }
      }
    },
    // 设置初始设备
    setInitialDevice() {
      if (!this.deviceId && (this.initialDeviceId || this.initialDeviceName)) {
        // 在所有设备类型中查找该设备
        let foundDevice = null;
        let foundDeviceType = "";

        for (const [typeName, devices] of Object.entries(
          this.deviceTypeOptions
        )) {
          // 优先使用设备ID查找
          if (this.initialDeviceId) {
            const device = devices.find(
              (d) => String(d.id) === String(this.initialDeviceId)
            );
            if (device) {
              foundDevice = device;
              foundDeviceType = typeName;
              break;
            }
          }
          // 如果没有找到或没有设备ID，使用设备名称查找
          if (!foundDevice && this.initialDeviceName) {
            const device = devices.find(
              (d) => d.deviceName === this.initialDeviceName
            );
            if (device) {
              foundDevice = device;
              foundDeviceType = typeName;
              break;
            }
          }
        }

        if (foundDevice) {
          // 设置设备类型
          this.deviceType = foundDeviceType;
          // 更新设备名称选项
          this.deviceNameOptions =
            this.deviceTypeOptions[foundDeviceType] || [];
          // 设置设备ID
          this.deviceId = foundDevice.id;
          // 自动触发设备名称变化，查询数据
          this.handleDeviceNameChange();
        }
      }
    },

    // 大棚变化：获取设备分类列表
    async handleGreenhouseChange() {
      // 清空设备类型和设备名称
      this.deviceType = "";
      this.deviceId = "";
      this.deviceNameOptions = [];
      this.deviceTypeOptions = {};
      // 清空表格数据
      this.tableData = [];
      this.tableColumns = [];
      this.pagination.total = 0;

      if (!this.greenhouseId) {
        return;
      }

      // 同时获取设备分类列表和所有设备列表（包含sensorId）
      let res, allDevicesRes;
      try {
        [res, allDevicesRes] = await Promise.all([
          getdeviceclassifylist({
            greenhouseId: this.greenhouseId,
          }),
          getallsblist(`greenhouseId=${this.greenhouseId}`),
        ]);
      } catch (error) {
        console.error("获取设备列表失败:", error);
        this.deviceTypeOptions = {};
        this.deviceIdToSensorIdMap = {};
        return;
      }

      const resPayload = Array.isArray(res)
        ? res
        : res && res.data
        ? res.data
        : [];
      console.log("设备", resPayload);

      // 获取所有设备列表（包含sensorId）
      const allDevicesPayload = Array.isArray(allDevicesRes)
        ? allDevicesRes
        : allDevicesRes && allDevicesRes.data
        ? allDevicesRes.data
        : allDevicesRes && allDevicesRes.success && allDevicesRes.data
        ? allDevicesRes.data
        : [];

      if (Array.isArray(resPayload)) {
        const resdata = this.transformData(resPayload);
        this.deviceTypeOptions = resdata.sbtypedetail;

        // 保存设备分类完整信息
        this.deviceClassifyInfo = {};
        resPayload.forEach((group) => {
          if (group.classifyName) {
            this.deviceClassifyInfo[group.classifyName] = {
              classifyId: group.classifyId,
              classifyName: group.classifyName,
              variableTypeList: group.variableTypeList || [],
              deviceList: group.deviceList || [],
            };
          }
        });

        // 构建设备ID到sensorId的映射和分类信息映射
        // 通过设备名称匹配：getdeviceclassifylist返回的name 和 getallsblist返回的deviceName
        this.deviceIdToSensorIdMap = {};
        this.deviceIdToClassifyInfoMap = {};
        const allDevicesMap = {}; // 设备名称到sensorId的映射
        if (Array.isArray(allDevicesPayload)) {
          allDevicesPayload.forEach((device) => {
            // getallsblist返回的id就是sensorId
            if (device.deviceName) {
              allDevicesMap[device.deviceName] = device.id;
            }
          });
        }

        // 遍历设备列表，通过名称匹配找到对应的sensorId
        Object.keys(this.deviceTypeOptions).forEach((classifyName) => {
          const classifyInfo = this.deviceClassifyInfo[classifyName];
          (this.deviceTypeOptions[classifyName] || []).forEach((dev) => {
            // 通过设备名称匹配：dev.deviceName（来自transformData）对应 allDevicesMap 的 key
            const sensorId = allDevicesMap[dev.deviceName] || dev.id;
            this.deviceIdToSensorIdMap[dev.id] = sensorId;
            // 保存设备ID到分类信息的映射
            this.deviceIdToClassifyInfoMap[dev.id] = {
              classifyId: classifyInfo?.classifyId,
              classifyName: classifyName,
              variableTypeList: classifyInfo?.variableTypeList || [],
            };
          });
        });

        console.log("设备ID到sensorId映射:", this.deviceIdToSensorIdMap);
        console.log("设备分类信息:", this.deviceClassifyInfo);

        // 如果有初始设备ID或设备名称，尝试设置它；否则默认选中第一个设备类型
        if (this.initialDeviceId || this.initialDeviceName) {
          this.$nextTick(() => {
            this.setInitialDevice();
          });
        } else {
          // 默认选中第一个设备类型
          const deviceTypeKeys = Object.keys(this.deviceTypeOptions);
          if (deviceTypeKeys.length > 0) {
            this.deviceType = deviceTypeKeys[0];
            // 触发设备类型变化，会自动选中第一个设备名称
            this.handleDeviceTypeChange();
          }
        }
      } else {
        this.deviceTypeOptions = {};
        this.deviceIdToSensorIdMap = {};
        this.deviceClassifyInfo = {};
        this.deviceIdToClassifyInfoMap = {};
      }
    },

    // 转换数据格式
    transformData(originalData) {
      const result = { sbtypedetail: {} };
      const list = Array.isArray(originalData)
        ? originalData
        : originalData && Array.isArray(originalData.data)
        ? originalData.data
        : [];
      if (!list.length) {
        return result;
      }
      // 新结构：[{ classifyId, classifyName, deviceList: [...], variableTypeList: [...] }, ...]
      list.forEach((group) => {
        const classifyName = group.classifyName;
        if (!classifyName) return;
        if (!result.sbtypedetail[classifyName]) {
          result.sbtypedetail[classifyName] = [];
        }
        (group.deviceList || []).forEach((dev) => {
          // sensorId优先使用dev.sensorId，如果没有则使用dev.id
          const sensorId = dev.sensorId || dev.id;
          result.sbtypedetail[classifyName].push({
            id: dev.id,
            createTime: dev.createTime,
            updateTime: dev.updateTime,
            deviceType: dev.deviceType,
            deviceName: dev.name,
            type: dev.classify,
            sensorId: sensorId,
          });
        });
      });

      return result;
    },

    // 设备类型变化：更新设备名称选项
    handleDeviceTypeChange() {
      this.deviceId = "";
      // 清空表格数据
      this.tableData = [];
      this.tableColumns = [];
      this.pagination.total = 0;
      if (this.deviceType && this.deviceTypeOptions[this.deviceType]) {
        this.deviceNameOptions = this.deviceTypeOptions[this.deviceType];
        // 默认选中第一个设备名称
        if (this.deviceNameOptions.length > 0) {
          this.deviceId = this.deviceNameOptions[0].id;
          // 自动触发设备名称变化，查询数据
          this.handleDeviceNameChange();
        }
      } else {
        this.deviceNameOptions = [];
      }
    },

    // 设备名称变化：自动查询数据
    async handleDeviceNameChange() {
      if (!this.deviceId) {
        // 清空表格数据
        this.tableData = [];
        this.tableColumns = [];
        this.pagination.total = 0;
        this.deviceVariablesLimits = {};
        return;
      }

      // 获取当前设备的变量限制信息
      this.loadDeviceVariablesLimits();

      // 检查时间范围是否存在
      if (!this.times) {
        // 如果没有时间范围，只构建表头，不查询数据
        const classifyInfo =
          this.deviceIdToClassifyInfoMap[this.deviceId] || {};
        this.buildTableColumns(classifyInfo);
        this.tableData = [];
        this.pagination.total = 0;
        return;
      }

      // 从映射中获取对应的sensorId，如果没有则使用deviceId
      const sensorId =
        this.deviceIdToSensorIdMap[this.deviceId] || this.deviceId;
      const classifyInfo = this.deviceIdToClassifyInfoMap[this.deviceId] || {};

      // 构建表头
      this.buildTableColumns(classifyInfo);

      // 重置分页
      this.pagination.currentPage = 1;

      // 查询数据
      await this.fetchTableData();
    },

    // 数据类型变化：更新时间范围
    handleDataTypeChange() {
      const base = dayjs();
      let start;
      let end;

      switch (this.dataType) {
        case "MINUTES":
          start = base.subtract(12, "hour");
          end = base;
          break;
        case "DAYS":
          start = base.subtract(24, "hour");
          end = base;
          break;
        case "WEEKS":
          start = base.subtract(7, "day").startOf("day");
          end = base.endOf("day");
          break;
        case "MONTHS":
          start = base.subtract(30, "day").startOf("day");
          end = base.endOf("day");
          break;
        default:
          start = base.subtract(12, "hour");
          end = base;
          break;
      }

      this.times = [
        start.format("YYYY-MM-DD HH:mm:ss"),
        end.format("YYYY-MM-DD HH:mm:ss"),
      ];
    },

    // 时间范围变化：验证时间范围
    handleTimeChange(times) {
      if (!times || !Array.isArray(times) || times.length !== 2) {
        return;
      }
      if (
        new Date(times[1]).getTime() - new Date(times[0]).getTime() >
        2592000000
      ) {
        // 30天的毫秒数
        this.$message.error("最多选择30天");
        this.times = [
          dayjs().subtract(2, "hour").format("YYYY-MM-DD HH:mm:ss"),
          dayjs().format("YYYY-MM-DD HH:mm:ss"),
        ];
      }
    },

    // 加载设备变量限制信息
    loadDeviceVariablesLimits() {
      this.deviceVariablesLimits = {};
      
      if (!this.deviceId) {
        return;
      }

      const classifyInfo = this.deviceIdToClassifyInfoMap[this.deviceId] || {};
      const classifyName = classifyInfo.classifyName;
      
      if (!classifyName) {
        return;
      }

      // 从设备分类信息中找到当前设备
      const classifyData = this.deviceClassifyInfo[classifyName];
      if (!classifyData || !classifyData.deviceList) {
        return;
      }

      // 找到当前设备
      const currentDevice = classifyData.deviceList.find(
        (dev) => String(dev.id) === String(this.deviceId)
      );

      if (!currentDevice || !currentDevice.deviceVariables) {
        return;
      }

      // 构建变量类型到限制的映射
      // 如果某个类型的变量没有上下限，继续查找后面相同类型的变量
      currentDevice.deviceVariables.forEach((variable) => {
        if (variable.type) {
          // 检查是否已经有该类型的限制信息
          const existingLimit = this.deviceVariablesLimits[variable.type];
          
          // 如果还没有该类型的限制，或者现有的限制没有上下限值，则尝试更新
          if (!existingLimit || 
              (existingLimit.upperLimit === null && existingLimit.lowerLimit === null)) {
            // 只有当前变量有上限或下限时才更新
            if (variable.upperLimit !== null || variable.lowerLimit !== null) {
              this.deviceVariablesLimits[variable.type] = {
                upperLimit: variable.upperLimit,
                lowerLimit: variable.lowerLimit,
                unit: variable.unit || '',
              };
            } else if (!existingLimit) {
              // 如果是第一次遇到该类型且没有限制值，也要记录
              this.deviceVariablesLimits[variable.type] = {
                upperLimit: variable.upperLimit,
                lowerLimit: variable.lowerLimit,
                unit: variable.unit || '',
              };
            }
          }
        }
      });

      console.log('设备变量限制信息:', this.deviceVariablesLimits);
    },

    // 查询按钮
    async handleQuery() {
      if (!this.deviceId) {
        this.$message.warning("请选择设备");
        return;
      }
      if (!this.times || !this.times[0] || !this.times[1]) {
        this.$message.warning("请选择时间范围");
        return;
      }

      // 加载设备变量限制信息
      this.loadDeviceVariablesLimits();

      // 从映射中获取对应的sensorId，如果没有则使用deviceId
      const sensorId =
        this.deviceIdToSensorIdMap[this.deviceId] || this.deviceId;
      const classifyInfo = this.deviceIdToClassifyInfoMap[this.deviceId] || {};

      // 构建表头
      this.buildTableColumns(classifyInfo);

      // 重置分页
      this.pagination.currentPage = 1;

      // 查询数据
      await this.fetchTableData();
    },

    // 构建表格列
    buildTableColumns(classifyInfo) {
      const columns = [];
      const classifyName = classifyInfo.classifyName || "";

      // 使用valuekeylist根据设备类型名称构建列
      const variableList = this.valuekeylist[classifyName] || [];
      variableList.forEach((item) => {
        columns.push({
          prop: item.value, // 使用value作为prop，而不是variableTypeCode
          label: item.unit ? item.name + "(" + item.unit + ")" : item.name,
          unit: item.unit || "",
        });
      });

      this.tableColumns = columns;
    },

    // 获取棚外气象站变量元数据
    getWeatherStationVariableMeta() {
      return [
        {
          variableTypeCode: "windRank",
          variableTypeName: "风力",
          variableTypeUnit: "级",
        },
        {
          variableTypeCode: "windSpeed",
          variableTypeName: "风速",
          variableTypeUnit: "m/s",
        },
        {
          variableTypeCode: "windDirection",
          variableTypeName: "风向",
          variableTypeUnit: "",
        },
        {
          variableTypeCode: "temp",
          variableTypeName: "温度",
          variableTypeUnit: "℃",
        },
        {
          variableTypeCode: "humi",
          variableTypeName: "湿度",
          variableTypeUnit: "%",
        },
        {
          variableTypeCode: "light",
          variableTypeName: "光照",
          variableTypeUnit: "",
        },
        {
          variableTypeCode: "pressure",
          variableTypeName: "大气压",
          variableTypeUnit: "kPa",
        },
        {
          variableTypeCode: "rainfall",
          variableTypeName: "累计雨量",
          variableTypeUnit: "mm",
        },
        {
          variableTypeCode: "instantRainfall",
          variableTypeName: "瞬时雨量",
          variableTypeUnit: "mm",
        },
        {
          variableTypeCode: "currentRainfall",
          variableTypeName: "当前雨量",
          variableTypeUnit: "mm",
        },
        {
          variableTypeCode: "yesterdayRainfall",
          variableTypeName: "日雨量",
          variableTypeUnit: "mm",
        },
      ];
    },

    // 获取表格数据
    async fetchTableData() {
      if (!this.deviceId) {
        return;
      }

      this.tableLoading = true;
      try {
        const sensorId =
          this.deviceIdToSensorIdMap[this.deviceId] || this.deviceId;
        const classifyInfo =
          this.deviceIdToClassifyInfoMap[this.deviceId] || {};
        const classifyId = classifyInfo.classifyId;

        // 构建请求参数
        const requestData = {
          deviceId: this.deviceId,
          sensorId: sensorId,
          startTime: this.times[0],
          endTime: this.times[1],
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          chronoUnit: this.dataType,
        };

        const res = await gethistorydata(requestData);

        // 处理响应数据 - 支持多种数据结构
        let responseData = res.data || res || {};

        // 如果 responseData 中有嵌套的 data 对象，使用嵌套的 data
        if (responseData.data && typeof responseData.data === "object") {
          responseData = responseData.data;
        }

        // 获取列表数据，支持 records 或 list 字段
        const records = responseData.records || responseData.list || [];

        // 获取总数，支持 total、totalCount 字段，并处理字符串类型
        const total = parseInt(
          responseData.total || responseData.totalCount || 0,
          10
        );

        console.log("接口返回数据:", res);
        console.log("处理后的响应数据:", responseData);
        console.log("列表数据:", records);
        console.log("总数:", total);

        // 处理表格数据 - 统一使用normalizeTableData，因为都使用valuekeylist
        this.tableData = this.normalizeTableData(records, classifyInfo);

        this.pagination.total = total;
        // 更新表格key强制重新渲染，解决固定列错位问题
        this.tableKey += 1;
      } catch (error) {
        console.error("获取表格数据失败:", error);
        this.$message.error("获取数据失败");
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.tableLoading = false;
      }
    },

    // 标准化普通设备表格数据
    normalizeTableData(records, classifyInfo) {
      const classifyName = classifyInfo.classifyName || "";
      const variableList = this.valuekeylist[classifyName] || [];
      const variableCodes = variableList.map((item) => item.value);

      return records.map((record) => {
        const row = {
          time: record.time || record.createTime || record.collectTime || "",
        };

        // 处理每个变量类型的数据
        variableCodes.forEach((code) => {
          // 尝试从不同可能的字段中获取数据
          // 优先从 record 的顶层属性获取，然后尝试 variableData 或 data 对象
          row[code] =
            record[code] !== undefined && record[code] !== null
              ? record[code]
              : record.variableData && record.variableData[code] !== undefined
              ? record.variableData[code]
              : record.data && record.data[code] !== undefined
              ? record.data[code]
              : null;
        });

        return row;
      });
    },

    // 标准化棚外气象站表格数据
    normalizeWeatherStationTableData(records) {
      const variableList = this.valuekeylist["棚外气象站"] || [];
      const variableCodes = variableList.map((item) => item.value);

      return records.map((record) => {
        const row = {
          time: record.time || record.createTime || record.collectTime || "",
        };

        // 处理每个变量类型的数据
        variableCodes.forEach((code) => {
          // 尝试从不同可能的字段中获取数据
          row[code] =
            record[code] !== undefined && record[code] !== null
              ? record[code]
              : record.data && record.data[code] !== undefined
              ? record.data[code]
              : null;
        });

        return row;
      });
    },

    // 检查值是否超限
    isValueOutOfLimit(value, variableType) {
      if (value === null || value === undefined || value === '') {
        return false;
      }

      const limits = this.deviceVariablesLimits[variableType];
      if (!limits) {
        return false;
      }

      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        return false;
      }

      // 检查上限
      if (limits.upperLimit !== null && limits.upperLimit !== undefined) {
        if (numValue > limits.upperLimit) {
          return true;
        }
      }

      // 检查下限
      if (limits.lowerLimit !== null && limits.lowerLimit !== undefined) {
        if (numValue < limits.lowerLimit) {
          return true;
        }
      }

      return false;
    },

    // 获取单元格样式（用于超限标红）
    getCellStyle({ row, column, rowIndex, columnIndex }) {
      // 基础样式
      const baseStyle = {
        background: '#030a2e',
        color: '#fff',
        borderColor: '#2680dd',
      };

      // 如果是序号列或时间列，直接返回基础样式
      if (!column.property || column.property === 'time') {
        return baseStyle;
      }

      // 获取当前列对应的变量类型
      const classifyInfo = this.deviceIdToClassifyInfoMap[this.deviceId] || {};
      const classifyName = classifyInfo.classifyName || '';
      const variableList = this.valuekeylist[classifyName] || [];
      
      // 找到当前列对应的变量类型
      const variable = variableList.find((item) => item.value === column.property);
      if (!variable || !variable.type) {
        return baseStyle;
      }

      // 获取单元格的值
      const value = row[column.property];
      
      // 检查是否超限
      if (this.isValueOutOfLimit(value, variable.type)) {
        return {
          ...baseStyle,
          color: '#ff4d4f',
          fontWeight: 'bold',
        };
      }

      return baseStyle;
    },

    // 格式化单元格值
    formatCellValue(value, unit) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      let formattedValue = value;
      if (typeof value === "number") {
        // 保留2位小数，但如果是整数则不显示小数
        formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(2);
      }
      return unit ? `${formattedValue} ` : formattedValue;
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.fetchTableData();
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchTableData();
    },

    // 导出数据
    async handleExport() {
      if (!this.deviceId) {
        this.$message.warning("请先选择设备");
        return;
      }

      if (!this.times || !this.times[0] || !this.times[1]) {
        this.$message.warning("请选择时间范围");
        return;
      }

      this.exportLoading = true;
      try {
        const sensorId =
          this.deviceIdToSensorIdMap[this.deviceId] || this.deviceId;

        // 构建导出参数，与分页接口参数一致
        const exportParams = {
          deviceId: this.deviceId,
          sensorId: sensorId,
          startTime: this.times[0],
          endTime: this.times[1],
          chronoUnit: this.dataType,
        };

        const response = await exportMonitoringData(exportParams);

        // 处理文件流下载
        // 如果响应已经是Blob，直接使用；否则创建新的Blob
        let blob;
        if (response instanceof Blob) {
          blob = response;
        } else if (response.data instanceof Blob) {
          blob = response.data;
        } else {
          blob = new Blob([response.data || response], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
        }
        
        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.style.display = "none";

        // 生成文件名
        const fileName = `监测点数据_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`;
        link.setAttribute("download", fileName);
        
        // 触发下载
        document.body.appendChild(link);
        link.click();
        
        // 清理
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        this.$message.success("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        // 如果错误是Blob对象，说明可能是接口返回了错误信息
        if (error instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorMsg = JSON.parse(reader.result);
              this.$message.error(errorMsg.message || "导出失败");
            } catch (e) {
              this.$message.error("导出失败，请稍后重试");
            }
          };
          reader.readAsText(error);
        } else {
          this.$message.error(error.message || "导出失败，请稍后重试");
        }
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.data_table_main {
  width: 100%;
  background-color: #030a2e;
  padding: 20px;

  .search_bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-items: flex-start;
    .search_item {
      display: flex;
      align-items: center;
      .label {
        color: #fff;
        font-size: 16px;
        white-space: nowrap;
      }
    }
  }
}

/deep/ .el-select {
  .el-input__inner {
    background-color: transparent;
    border: 1px solid #2680dd;
    color: #fff;
  }
}

/deep/ .el-radio-button__inner {
  color: #e7f0ff;
  background: #03072e;
  border: 1px solid #2680dd;
  font-size: 14px;
}

/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background: #2680dd;
  border: 1px solid #2680dd;
}

/deep/ .el-date-editor {
  .el-range-input {
    background-color: transparent;
    color: #fff;
  }

  .el-range-separator {
    color: #fff;
  }
}

.table_container {
  margin-top: 20px;
  width: 100%;

  .pagination_container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}

/deep/ .el-pagination {
  .el-pagination__total,
  .el-pagination__jump {
    color: #fff;
  }

  .el-pagination__sizes .el-input .el-input__inner {
    background-color: transparent;
    border: 1px solid #2680dd;
    color: #fff;
  }

  .btn-prev,
  .btn-next,
  .el-pager li {
    background-color: transparent;
    color: #fff;
    border: 1px solid #2680dd;
  }

  .btn-prev:hover,
  .btn-next:hover,
  .el-pager li:hover {
    color: #2680dd;
  }

  .el-pager li.active {
    background-color: #2680dd;
    color: #fff;
  }

  .el-pagination__editor .el-input__inner {
    background-color: transparent;
    border: 1px solid #2680dd;
    color: #fff;
  }
}
</style>
